import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import styled, { ThemeProvider } from 'styled-components';
import { motion } from 'framer-motion';
import Numeral from 'numeral';
import { mdiCalculator, mdiChevronRight, mdiProgressCheck } from '@mdi/js';
import { Copy, ZeroState, Alert, Modal } from '@hexure/ui';
import _orderBy from 'lodash/orderBy';

import Loader from 'shared/Loader';

// import ComparisonModal from 'annuities/ComparisonModal';
import CriteriaCard from 'annuities/CriteriaCard';
import CriteriaModal from 'annuities/CriteriaModal';
import ResultsBar from 'annuities/ResultsBar';
import LoadingQuote from 'annuities/LoadingQuote';
import QuoteCard from 'annuities/QuoteCard';
import QuoteActionModal from 'annuities/QuoteActionModal';

import ApiUtils from 'utils/AnnuitiesApi';
import FormUtils from 'utils/Form';

import { ProductContext } from 'annuities/Context';
import { ThemeContext } from 'shared/ThemeContext';

import { Colors } from 'constants/Clementine';

import { STATES, AMBEST_SORTING } from 'constants/App';
import VisualizeModal from '../components/annuities_quoter/VisualizeModal';
import { isEqual, parseInt } from 'lodash';
import PdfActions from '../components/shared/PdfActions';
import { createRoot } from 'react-dom/client';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

const config = require('../config/App');

posthog.init(config.PostHogKey, {
  api_host: 'https://us.i.posthog.com'
});

window.IXN = {};
const IXN_AUTH = Cookies.get('ixn') ? Cookies.getJSON('ixn') : null;
//const COOKIED_CRITERIA = Cookies.getJSON('hexure_annuities');
const QUOTER_CONFIG = window.HEXURE_AQ_CONFIG;

const Widget = styled.div`
  display: flex;
  flex-direction: ${props => (props.$layout === 'horizontal' ? 'row' : 'column')};
  gap: 20px;
`;

const Criteria = styled.div`
  display: flex;
  gap: 20px;
  width: ${props => (props.$layout === 'horizontal' ? '100%' : 'auto')};
  flex-direction: ${props => (props.$layout === 'horizontal' ? 'column' : 'row')};
  flex-shrink: 0;
`;

const Results = styled.div`
  display: flex;
  gap: 20px;
  flex: 1;
  flex-direction: ${props => (props.$layout === 'horizontal' ? 'row' : 'column')};
`;

const Quotes = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const EmptyState = styled.div`
  width: 100%;
  padding: 60px 0;
  border-radius: 8px;
  border: 1px dashed '#ff0000';
  background: #fff;
`;

const EmptyStateContent = styled.div`
  width: 100%;
  margin: 0 auto;
`;

const RerunContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 200px;
`;

const allProductTypes = [{ value: 'Fixed Indexed Annuity' }, { value: 'Fixed Annuity' }, { value: 'Multi-Year Guaranteed Annuity' }];

function hexToRgb(hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}` : null;
}

const AnnuitiesQuoter = () => {
  const layout = 'vertical';
  const [loading, setLoading] = useState(true);
  const [isRerunQuoteOpen, SetIsRerunQuoteOpen] = useState(window.IXN_QUOTER_CONFIG?.embed_context ?? false);
  const [auth, setAuth] = useState(IXN_AUTH);
  const [carriers, setCarriers] = useState([]);
  const [products, setProducts] = useState([]);
  const [products_features, setProductsFeatures] = useState([]);
  const [quoter, setQuoter] = useState(null);
  const [solveType, setSolveType] = useState(null);
  const [error, setError] = useState(null);
  const [limitProductTypes, setLimitProductTypes] = useState([]);
  const [criteriaOptions, setCriteriaOptions] = useState({
    default_state: 'AL',
    states: STATES,
    product_types: [],
    required_agent_info: [],
    features: products_features?.map(c => c.id) || []
  });
  const [criteriaTab, setCriteriaTab] = useState('agent');
  const [aaq, setAAQ] = useState(null);
  const [modal, setModal] = useState(null);
  const [agent, setAgent] = useState(null);
  const [trackAgent, setTrackAgent] = useState(null);
  const [trackClient, setTrackClient] = useState(null);
  const [trackSolve, setTrackSolve] = useState(null);
  const [trackProduct, setTrackProduct] = useState(null);
  const [agentErrors, setAgentErrors] = useState([]);
  const [client, setClient] = useState(null);
  const [clientErrors, setClientErrors] = useState([]);
  const [product, setProduct] = useState(null);
  const [productErrors, setProductErrors] = useState([]);
  const [solve, setSolve] = useState(null);
  const [solveErrors, setSolveErrors] = useState([]);
  const [quotes, setQuotes] = useState([]);
  const [oldAgent, setOldAgent] = useState(null);
  const [oldClient, setOldClient] = useState(null);
  const [oldProduct, setOldProduct] = useState(null);
  const [oldSolve, setOldSolve] = useState(null);
  const [visible_quotes, setVisibleQuotes] = useState([]);
  const [loadingQuotes, setLoadingQuotes] = useState(false);
  const [selectedQuotes, setSelectedQuotes] = useState([]);
  const [quote, setQuote] = useState(null);
  const [paginationQuotes, setPaginationQuotes] = useState([]);
  const [currentProduct, setCurrentProduct] = useState(null);
  const [loadedQuotes, setLoadedQuotes] = useState([]);
  const [quoteCount, setQuoteCount] = useState(3);
  const [carriersAndProductFeatures, setCarriersAndProductFeatures] = useState(false);
  const [filters, setFilters] = useState({
    sort_by: solve?.solve_for === 'GMBIncome' || solve?.solve_for === 'Contribution' ? 'premium' : solve?.solve_for === 'Accumulation' ? 'accumulation' : 'monthly_income',
    sort_dir: 'asc',
    filter_by: solve?.solve_for === 'GMBIncome' || solve?.solve_for === 'Contribution' ? 'premium' : solve?.solve_for === 'Accumulation' ? 'accumulation' : 'monthly_income',
    filter_low: 0,
    filter_high: 1000000,
    filter_range: [0, 1000000],
    filter_values: [],
    search: ''
  });
  const first_view = !client && !product && !solve;
  const invalid_criteria = agentErrors.length || clientErrors.length || productErrors.length || solveErrors.length;
  const theme_context = {
    color: quoter?.theme_options?.secondary_color || Colors.BLUE.hex
  };
  const product_context = {
    auth: IXN_AUTH
  };
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  const showCriteria = tab => {
    setModal('criteria');
    setCriteriaTab(tab);
  };

  const loadMember = () => {
    if (auth?.id) {
      ApiUtils.loadMember(auth.id).then(({ data }) => {
        applyCriteria(
          {
            first_name: data.first_name || agent?.first_name,
            last_name: data.last_name || agent?.last_name,
            email: data.email || agent?.email,
            phone: data.phone || agent?.phone,
            insurance_license_number: data.insurance_license_number || agent?.insurance_license_number
          },
          client,
          product,
          solve
        );
      });
    }
  };

  const validateCriteria = (group, name, value) => {
    let is_valid = true;
    if (group === 'agent') {
      if (['first_name', 'last_name', 'insurance_license_number'].includes(name) && !value) {
        is_valid = false;
      }

      if (name === 'email' && !FormUtils._validateEmail(value)) {
        is_valid = false;
      }

      if (name === 'phone' && !FormUtils._validatePhone(value)) {
        is_valid = false;
      }
    }

    if (group === 'product') {
      if (name === 'carrier_ids' && !value?.length) {
        is_valid = false;
      }
    }

    if (group === 'solve') {
      if (['gmb_start_year', 'start_year_offset'].includes(name) && !value) {
        is_valid = false;
      }
      if (['premium', 'income'].includes(name) && (!value || value === '0')) {
        is_valid = false;
      }
    }

    return is_valid;
  };

  const addCusipsToQuotes = (products, quotes) => {
    return quotes?.map(quote => {
      const quoted_product = products?.find(product => quote.product_id === product.id);

      return { ...quote, product_cusip: quoted_product.cusip };
    });
  };
  const addEmbedConfigQuoteActions = quotes => {
    const embed_config_quote_actions = [];

    QUOTER_CONFIG.quote_actions.forEach(quote_action => {
      const enabled_quote_guids = [];

      quotes.forEach(quote => {
        if (quote_action.should_show(quote)) {
          enabled_quote_guids.push(quote.guid);
        }
      });

      embed_config_quote_actions.push({ ...quote_action, enabled_quote_guids });
    });

    setAAQ(prev_state => {
      return { ...prev_state, embed_config_quote_actions };
    });
  };

  const applyCriteria = (agent, client, product, solve) => {
    if (agent && Object.keys(agent)?.length) {
      const errors = [];

      criteriaOptions?.required_agent_info?.forEach(name => {
        if (!validateCriteria('agent', name, agent[name])) {
          errors.push(name);
        }
      });

      setAgent(agent);
      setAgentErrors(errors);
    }

    if (client && Object.keys(client)?.length) {
      const errors = [];
      setClient(client);
      setClientErrors(errors);
    }

    if (product && Object.keys(product)?.length) {
      const errors = [];

      ['carrier_ids'].forEach(name => {
        if (!validateCriteria('product', name, product[name])) {
          errors.push(name);
        }
      });

      if (product?.product_types && ['Fixed Annuity', 'Fixed Indexed Annuity'].includes(product.product_types[0])) {
        delete product.market_value_adjustment;
      }
      if (product?.product_types && ['Fixed Indexed Annuity', 'Multi-Year Guaranteed Annuity'].includes(product.product_types[0])) {
        delete product.bonus_exc;
        delete product.bonus_rate;
      }

      if (product?.product_types && ['Multi-Year Guaranteed Annuity'].includes(product.product_types[0])) {
        delete product.surrender_charge_period;
        delete product.income_start_date;
        delete product.income_payment_mode;
        delete product.payment_option;
      }

      if (product?.product_types && ['Single Premium Immediate Annuity', 'Deferred Income Annuity'].includes(product.product_types[0])) {
        // delete product.guaranteed_period;
        delete product.market_value_adjustment;
        delete product.surrender_charge_period;

        // check for at least one option in payment_option
      }

      setProduct(product);
      setProductErrors(errors);
    }

    if (solve && Object.keys(solve)?.length) {
      const errors = [];

      // if (solve.solve_for === 'Premium') {
      //   solve.premium = 0;
      //   if (!validateCriteria('solve', 'income', solve.income)) {
      //     errors.push('income');
      //   }
      // }

      // if (solve.solve_for === 'Income') {
      //   solve.income = 0;
      //   if (!validateCriteria('solve', 'premium', solve.premium)) {
      //     errors.push('premium');
      //   }
      //   if (!validateCriteria('solve', 'gmb_start_year', solve.gmb_start_year) && solve.gmb_start_year === '') {
      //     errors.push('gmb_start_year');
      //   }
      //   if (!validateCriteria('solve', 'start_year_offset', solve.start_year_offset) && solve.start_year_offset === '') {
      //     errors.push('start_year_offset');
      //   }
      // }
      if (!validateCriteria('solve', 'premium', solve.premium)) {
        errors.push('premium');
      }

      setSolve(solve);
      setSolveErrors(errors);
    }

    // Save the quote with the updated criteria to FireLight
    if (typeof window.saveQuote === 'function') {
      window.saveQuote();
    }
  };

  const getQuotes = () => {
    if (!invalid_criteria && !first_view) {
      const params = {
        ...client,
        agent: { ...agent },
        ...product,
        ...solve,
        product_ids: products?.filter(p => product?.carrier_ids?.includes(p.carrier_id))?.map(p => p.id),
        product_types: product?.product_types[0] === 'Multi-Year Guaranteed Annuity' ? ['MYGA'] : product?.product_types
      };

      setLoadingQuotes(true);
      setQuotes([]);
      setSelectedQuotes([]);
      setError(null);
      setPaginationQuotes([]);

      ApiUtils.getQuotes(params)
        .then(quotes => {
          const filter_by = solve?.solve_for === 'GMBIncome' || solve?.solve_for === 'Contribution' ? 'premium' : solve?.solve_for === 'Accumulation' ? 'accumulation' : 'monthly_income';
          const values = quotes?.map(q => parseInt(q[filter_by], 10));
          const lowest_value = values.length ? Math.floor(Math.min(...values)) : 0;
          const highest_value = values.length ? Math.ceil(Math.max(...values)) + 1 : 1000000;

          setQuotes(quotes);
          setFilters({
            sort_by: filter_by,
            sort_by: filter_by,
            sort_dir: 'desc',
            filter_by,
            filter_by,
            filter_low: lowest_value,
            filter_high: highest_value,
            filter_range: [lowest_value, highest_value],
            filter_values: values,
            search: ''
          });
          setLoadingQuotes(false);
          Cookies.set(
            'hexure_annuities',
            {
              agent,
              client,
              product,
              solve
            },
            { domain: window.location.hostname }
          );
          if (QUOTER_CONFIG.quote_actions && QUOTER_CONFIG.quote_actions.length) {
            if (QUOTER_CONFIG.embed_context === 'fire_light') {
              const batchSize = 200;

              const productPromises = [];
              for (let i = 0; i < quotes.length; i += batchSize) {
                const batchIds = quotes.slice(i, i + batchSize).map(q => q.product_id);
                productPromises.push(ApiUtils.loadProduct({ id: batchIds }));
              }
              Promise.all(productPromises)
                .then(responses => {
                  const allProductData = responses.flatMap(response => response);
                  const quotes_with_cusips = addCusipsToQuotes(allProductData, quotes);
                  addEmbedConfigQuoteActions(quotes_with_cusips);
                  setQuotes(quotes_with_cusips);
                  setPaginationQuotes(quotes_with_cusips);
                })
                .catch(error => {
                  // handle errors
                });
            } else {
              addEmbedConfigQuoteActions(quotes);
            }
          }
        })
        .catch(() => {
          // TODO: Handle error response, display error in quote results area
          setError({ type: -1, message: 'No quotes Found' });
          setLoadingQuotes(false);
        });
    }
  };

  const handleQuoteSelect = id => {
    if (selectedQuotes.includes(id)) {
      setSelectedQuotes(selectedQuotes?.filter(q => q !== id));
    } else {
      setSelectedQuotes([...selectedQuotes, id]);
    }
  };

  const handleCompareSelected = () => {
    setModal('comparison');
  };
  const handleShare = () => {
    setModal('share');
  };

  const handleShowQuoteActions = quote => {
    setModal('actions');
    setQuote(quote);
  };

  const handleFilterChange = (name, e) => {
    const newFilters = {
      ...filters,
      [name]: e.target.value ? e.target.value : ''
    };

    if (name === 'sort_by') {
      const filter_field = e.target.value;
      let values = [];
      let lowest_value = 0;
      let highest_value = 1000000;

      if (quotes.length > 0) {
        if (filter_field === 'ambest') {
          const AMBEST_VALUES = {
            'A++': 10,
            'A+': 9,
            A: 8,
            'A-': 7,
            'B++': 6,
            'B+': 5,
            B: 4,
            'B-': 3,
            'C++': 2,
            'C+': 1,
            C: 0
          };
          values = quotes.map(q => AMBEST_VALUES[q.am_best_rating] || 9); // Default to A+ if unknown
          lowest_value = Math.min(...values);
          highest_value = Math.max(...values);
        } else if (filter_field === 'carrier') {
          // For carrier name, we can't really filter by range, so keep original values
          values = quotes.map(q =>
            parseInt(q[solve?.solve_for === 'GMBIncome' || solve?.solve_for === 'Contribution' ? 'premium' : solve?.solve_for === 'Accumulation' ? 'accumulation' : 'monthly_income'], 10)
          );
          lowest_value = Math.floor(Math.min(...values));
          highest_value = Math.ceil(Math.max(...values)) + 1;
        } else {
          values = quotes.map(q => {
            const value = q[filter_field];
            return typeof value === 'number' ? value : parseFloat(value) || 0;
          });
          lowest_value = Math.floor(Math.min(...values));
          highest_value = Math.ceil(Math.max(...values)) + 1;
        }
      }

      newFilters.filter_by = filter_field;
      newFilters.filter_low = lowest_value;
      newFilters.filter_high = highest_value;
      newFilters.filter_range = [lowest_value, highest_value];
      newFilters.filter_values = values;
    }

    setFilters(newFilters);
  };

  const handleAgentLogin = agent => {
    setModal(null);
    setAgent(agent);
    window.IXN.get_quoter_config().agent = agent;
    validateCriteria();
  };

  const handleModal = (modal, product) => {
    setModal(modal);
    setCurrentProduct(product);
  };

  function handleRerunQuote() {
    SetIsRerunQuoteOpen(false);
    applyCriteria(agent, client, product, solve);
  }

  // infinite scroll for the quotessection

  const handleScroll = () => {
    const element = document.getElementById('hexure-annuities-quoter');
    if (element) {
      if (window.innerHeight + window.scrollY >= document.body.offsetHeight && !loading) {
        setQuoteCount(prevCount => prevCount + 1);
      }
    }
  };

  const allPropsHaveValue = obj => {
    if (obj === null || typeof obj !== 'object') {
      return false;
    }

    for (const key in obj) {
      const value = obj[key];
      if (value === null || value === undefined || value === '') {
        return false;
      }
    }

    return true;
  };

  const isSolveStateValid = () => {};

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [loading]);

  useEffect(() => {
    if (window?.IXN_QUOTER_CONFIG?.embed_context === 'fire_light') {
      setQuoteCount(10);
    } else {
      setQuoteCount(10);
    }
  }, [paginationQuotes]);

  useEffect(() => {
    // Load initial set of images
    setLoadedQuotes(paginationQuotes.slice(0, quoteCount));
  }, [quoteCount, paginationQuotes]);

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    ApiUtils.loadQuoter()
      .then(({ data }) => {
        const filterList = ['Fixed Indexed Annuity', 'Fixed Annuity', 'Multi-Year Guaranteed Annuity'];
        const isLimit_product_types = filterList.some(item => data?.product_types.includes(item));
        if (data?.product_types?.length > 0 && isLimit_product_types) {
          const limit_product_types = data?.product_types?.filter(item => filterList.includes(item)).map(value => ({ value }));
          setLimitProductTypes(limit_product_types);
          setCriteriaOptions({ ...criteriaOptions, required_agent_info: data.required_agent_info, product_types: limit_product_types });
        } else {
          // The absence of a product type list caused all Product Types to be setup.
          setLimitProductTypes(allProductTypes);
          setCriteriaOptions({ ...criteriaOptions, required_agent_info: data.required_agent_info, product_types: allProductTypes });
        }
        setQuoter(data);
        if (data.solve_type !== null && data.solve_type !== undefined) {
          setSolveType(data.solve_type);
        }
        //Actions for next activity in Firelight
        setAAQ(data);
      })
      .catch(error => {
        setLoading(false);

        if (error.response && error.response.data) {
          setError(error.response.data[0]);
        } else {
          setError({ type: -1, message: 'Please Provide the BGA-Quoter Token' });
        }
      });
  }, []);

  useEffect(() => {
    if (!quoter) {
      return;
    }

    setLoading(true);

    setCriteriaOptions({
      default_state: quoter.default_state || quoter.states[0] || 'AL',
      states: STATES.filter(s => quoter?.states?.includes(s.value)),
      required_agent_info: quoter?.required_agent_info || [],
      product_types: quoter?.product_types?.length ? criteriaOptions?.product_types?.filter(pt => quoter?.product_types?.includes(pt.value)) : criteriaOptions?.product_types
    });
    const batchSize = 200;

    const productPromises = [];
    const productFeatures = ['Death Benefits', 'Income Benefits', 'Living Benefits', 'Market Value Adjustment', 'Online Application'];

    for (let i = 0; i < quoter.product_ids.length; i += batchSize) {
      const batchIds = quoter.product_ids.slice(i, i + batchSize);
      productPromises.push(ApiUtils.loadProduct({ id: batchIds }));
    }

    Promise.all([ApiUtils.loadCarriers({ id: quoter.carrier_ids }), ApiUtils.loadProductFeatures(), ...productPromises])
      .then(responses => {
        const carrier = responses.shift();
        const product_features = responses?.shift()?.filter(feature => productFeatures?.includes(feature.name));
        const products = responses
          ?.flatMap(innerArray => innerArray)
          ?.map(product => {
            product.features = product?.product_feature_ids?.map(id => {
              return product_features?.find(pf => pf.id === id);
            });
            return product;
          });

        setCarriers(carrier);
        setProducts(products);
        setProductsFeatures(product_features);
        setCriteriaOptions({ ...criteriaOptions, features: product_features?.map(c => c.id) });
        setLoading(false);
        setCarriersAndProductFeatures(true);
      })
      .catch(() => {
        setError({
          type: -1,
          message: 'Unable to load the data needed for the quoter'
        });
        setLoading(false);
        setCarriersAndProductFeatures(true);
      });
  }, [quoter]);

  useEffect(() => {
    const agentDataChanged = !isEqual(agent, oldAgent);

    const clientDataChanged = !isEqual(client, oldClient);

    const productDataChanged = !isEqual(product, oldProduct);

    const solveDataChanged = !isEqual(solve, oldSolve);

    if (agentDataChanged || clientDataChanged || productDataChanged || solveDataChanged) {
      setQuotes([]);
      applyCriteria(agent, client, product, solve);
      if (!invalid_criteria) {
        getQuotes();
      }
      setOldAgent(agent);
      setOldClient(client);
      setOldProduct(product);
      setOldSolve(solve);
    }
  }, [agent, client, product, solve]);

  useEffect(() => {
    loadMember();
  }, [auth]);

  useEffect(() => {
    const filtered_quotes = quotes?.filter(q => {
      let matches_value = true;

      if (filters.filter_by === 'ambest') {
        const AMBEST_VALUES = {
          'A++': 10,
          'A+': 9,
          A: 8,
          'A-': 7,
          'B++': 6,
          'B+': 5,
          B: 4,
          'B-': 3,
          'C++': 2,
          'C+': 1,
          C: 0
        };
        const rating_value = AMBEST_VALUES[q.am_best_rating] || 9;
        matches_value = rating_value >= filters?.filter_range[0] && rating_value <= filters?.filter_range[1];
      } else if (filters.filter_by === 'carrier') {
        // For carrier, don't apply range filter, just use search
        matches_value = true;
      } else {
        const field_value = typeof q[filters.filter_by] === 'number' ? q[filters.filter_by] : parseFloat(q[filters.filter_by]) || 0;
        matches_value = field_value >= filters?.filter_range[0] && field_value <= filters?.filter_range[1];
      }

      let matches_search = true;
      if (filters.search?.length) {
        const search_string = filters?.search?.toLowerCase();
        matches_search = q.carrier_name?.toLowerCase().includes(search_string) || q.product_name.toLowerCase().includes(search_string);
      }

      return matches_value && matches_search;
    });

    const sorted_quotes = _orderBy(
      filtered_quotes,
      q => {
        switch (filters.sort_by) {
          case 'ambest':
            return AMBEST_SORTING[q.am_best_rating || 'A+']; // TODO: Remove fallback after demo
          case 'base_rate':
            return q.base_rate;
          case 'carrier':
            return q.carrier_name.toLowerCase();
          case 'current_rate':
            return q.current_rate;
          case 'gtd_rate_years':
            return q.gtd_rate_years;
          case 'monthly_income':
            return q.monthly_income;
          case 'accumulation':
            return q.accumulation;
          case 'premium':
            return q.premium;
          case 'surrender_charge':
            return q.surrender_charge;
          default:
            return true;
        }
      },
      [filters.sort_dir]
    );

    setVisibleQuotes(sorted_quotes);
  }, [filters, quotes]);

  if (quoter && carriersAndProductFeatures) {
    window.IXN.get_quoter_config = () => {
      return {
        agent: {
          first_name: trackAgent?.first_name || agent?.first_name || '',
          last_name: trackAgent?.last_name || agent?.last_name || '',
          email: trackAgent?.email || agent?.email || '',
          phone: trackAgent?.phone || agent?.phone || '',
          insurance_license_number: trackAgent?.insurance_license_number || agent?.insurance_license_number || ''
        },
        client: {
          first_name: trackClient?.first_name || client?.first_name || '',
          last_name: trackClient?.last_name || client?.last_name || ''
        },
        quote_data: {
          date_of_birth: trackClient?.date_of_birth || client?.date_of_birth || '',
          current_age: trackClient?.current_age || client?.current_age || '',
          gender: trackClient?.gender || client?.gender || 'Male',
          state: trackClient?.state || client?.state || 'AL',
          nearest_age: trackClient?.nearest_age || client?.nearest_age || '',
          product_types: trackProduct?.product_types || product?.product_types || ['Fixed Indexed Annuity'],
          carrier_ids: trackProduct?.carrier_ids || product?.carrier_ids || [],
          premium: trackSolve?.premium || solve?.premium || 0,
          product_features: trackProduct?.features || product?.features || [],
          am_best_rating: trackProduct?.am_best_rating || product?.am_best_rating || ['Any'],
          bonus_rate: trackProduct?.bonus_rate || product?.bonus_rate || false,
          bonus_exc: trackProduct?.bonus_exc || product?.bonus_exc || false,
          gmb_rider: trackProduct?.gmb_rider || product?.gmb_rider || true,
          index_id: trackProduct?.index_id || product?.index_id || '',
          min_initial_rate: trackProduct?.min_initial_rate || product?.min_initial_rate || '0.0',
          guaranteed_period: trackProduct?.guaranteed_period || product?.guaranteed_period || ['0'],
          surrender_charge_period: trackProduct?.surrender_charge_period || product?.surrender_charge_period || '',
          tax_qualification: trackProduct?.tax_qualification || product?.tax_qualification || 'Non-Qualified'
        }
      };
    };
    window.IXN.update_quoter_config = data => {
      // AGENT
      if (data.agent) {
        setAgent(prevAgent => ({
          ...prevAgent,
          ...data.agent
        }));
      }
      // CLIENT
      if (data.client || data.quote_data || data.proposed_insured) {
        setClient(prevClient => {
          const annuity = data.proposed_insured?.annuity;
          const quoteData = data.quote_data;

          const quoteDateOfBirth =
            quoteData?.date_of_birth ||
            (quoteData?.dob_year && quoteData?.dob_month && quoteData?.dob_day
              ? `${quoteData.dob_year}-${String(quoteData.dob_month).padStart(2, '0')}-${String(quoteData.dob_day).padStart(2, '0')}`
              : undefined);

          return {
            ...prevClient,
            ...(data.client || {}),

            // Annuity values override client
            ...(annuity?.date_of_birth && {
              date_of_birth: annuity.date_of_birth
            }),
            ...(annuity?.gender && {
              gender: annuity.gender
            }),
            ...(annuity?.state && {
              state: annuity.state
            }),

            // Quote data overrides annuity
            ...(quoteDateOfBirth && {
              date_of_birth: quoteDateOfBirth
            }),
            ...(quoteData?.gender && {
              gender: quoteData.gender
            }),
            ...(quoteData?.state && {
              state: quoteData.state
            }),
            ...(quoteData?.current_age != null && {
              current_age: quoteData.current_age
            }),
            ...(quoteData?.nearest_age != null && {
              nearest_age: quoteData.nearest_age
            })
          };
        });
      }
      // QUOTE DATA
      if (data.quote_data) {
        const { carrier_ids, product_features, premium } = data.quote_data;

        const defaultProductTypes = data?.quote_data?.product_types?.length > 0 ? data.quote_data.product_types : ['Fixed Indexed Annuity'];

        const defaultProductType = defaultProductTypes[0];

        const filteredProductTypes = limitProductTypes?.filter(pt => pt.value !== defaultProductType);

        setCriteriaOptions(prevCriteriaOptions => ({
          ...prevCriteriaOptions,
          product_types: [{ value: defaultProductType }, ...filteredProductTypes],
          required_agent_info: quoter?.required_agent_info || []
        }));

        setProduct(prevProductData => ({
          ...prevProductData,
          product_types: defaultProductTypes,
          am_best_rating: data.quote_data?.am_best_rating || ['Any'],
          min_initial_rate: data.quote_data?.min_initial_rate || '0.0',
          tax_qualification: data.quote_data?.tax_qualification || 'Non-Qualified',
          bonus_rate: data.quote_data?.bonus_rate || false,
          bonus_exc: data.quote_data?.bonus_exc || false,
          gmb_rider: data.quote_data?.gmb_rider || true,
          index_id: data.quote_data?.index_id || '',
          features: data.quote_data?.products_features?.map(p => p.id) || [],
          guaranteed_period: data.quote_data?.guaranteed_period || ['0'],
          surrender_charge_period: data.quote_data?.surrender_charge_period || '',
          carrier_ids: carriers?.map(c => c.id) || [],
          ...(product_features && { product_features })
        }));
        setSolve(prevSolveData => ({
          ...prevSolveData,
          solve_for: data?.quote_data?.solve_for || 'Accumulation',
          premium: data?.quote_data?.premium || 150000,
          income: data?.quote_data?.income || 150000,
          quote_value: data?.quote_data?.quote_value || '1'
        }));

        // Update solve state
        // if (premium) {
        //   setSolve(prevSolveData => ({
        //     ...prevSolveData,
        //     premium
        //   }));
        // }
      }
    };
    window.IXN.disableQuoter = () => {};
    window.IXN.enableQuoter = () => {};
  }

  return loading ? (
    <Loader />
  ) : (
    <ThemeProvider theme={{ PRIMARY_COLOR: { Hex: theme_context.color, Rgb: hexToRgb(theme_context.color) } }}>
      <ThemeContext.Provider value={theme_context}>
        <ProductContext.Provider value={{ ...product_context, aaq, agent, client, annuities: quoter, handleAgentLogin }}>
          {/* {!error && <Notification color={theme_context.color} message='Welcome to Annuities Quoter' />}
          {error && <Notification color={'red'} message={error.message} />} */}
          {isRerunQuoteOpen && allPropsHaveValue(agent) && allPropsHaveValue(client) && allPropsHaveValue(product) && allPropsHaveValue(solve) ? (
            <Modal
              onClose={handleRerunQuote}
              primaryButton={{
                children: 'Rerun Quote',
                icon: null,
                onClick: handleRerunQuote
              }}
              title='Rate Change'
            >
              <RerunContainer>
                <Copy>Due to ever changing rates, some saved quotes need to be recalculated.</Copy>
                <Copy>Please click "Rerun Quote" below to proceed.</Copy>
              </RerunContainer>
            </Modal>
          ) : null}

          {modal === 'criteria' ? (
            <CriteriaModal
              agent={agent}
              agentErrors={agentErrors}
              auth={auth}
              authenticated={!!auth}
              carriers={carriers}
              client={client}
              clientErrors={clientErrors}
              criteriaOptions={criteriaOptions}
              onApply={applyCriteria}
              onClose={setModal.bind(null, null)}
              product={product}
              productErrors={productErrors}
              productsFeatures={products_features}
              setAuth={setAuth}
              setTrackAgent={setTrackAgent}
              setTrackClient={setTrackClient}
              setTrackProduct={setTrackProduct}
              setTrackSolve={setTrackSolve}
              solve={solve}
              solveErrors={solveErrors}
              solveType={solveType}
              tab={criteriaTab}
              validateCriteria={validateCriteria}
            />
          ) : null}

          {modal === 'comparison' ? <PdfActions agent={agent} client={client} onClose={setModal.bind(null, null)} product={product} selectedQuotes={selectedQuotes} /> : null}

          {modal === 'share' ? <PdfActions agent={agent} client={client} onClose={setModal.bind(null, null)} product={product} selectedQuotes={selectedQuotes} /> : null}

          {modal === 'actions' ? (
            <QuoteActionModal
              actions={quoter.quote_actions}
              onClose={() => {
                setModal(null);
                setQuote(null);
              }}
              quote={quote}
              quoteData={{ agent, client, product, solve }}
            />
          ) : null}

          {modal === 'visualize' ? <VisualizeModal onClose={setModal.bind(null, null)} product={currentProduct} quote={quote} /> : null}
          <Widget $layout={layout}>
            <Criteria $layout={windowWidth < 900 ? 'horizontal' : 'vertical'}>
              <CriteriaCard errorCount={agentErrors.length} onClick={showCriteria.bind(null, 'agent')} title='Agent Info'>
                {agent ? (
                  <>
                    <Copy color={agentErrors.includes('first_name') || agentErrors.includes('last_name') ? 'RED' : 'BLACK'}>
                      {!agent.first_name || !agent.last_name ? 'Missing Name' : `${agent.first_name} ${agent.last_name}`}
                    </Copy>
                    <Copy color={agentErrors.includes('email') ? 'RED' : 'BLACK'}>{agent.email || 'Email Missing'}</Copy>
                    <Copy color={agentErrors.includes('phone') ? 'RED' : 'BLACK'}>{agent.phone ? FormUtils._formatAsPhone(agent.phone) : 'Phone Missing'}</Copy>
                    <Copy color={agentErrors.includes('insurance_license_number') ? 'RED' : 'BLACK'}>{agent.insurance_license_number || 'License Missing'}</Copy>
                  </>
                ) : null}
              </CriteriaCard>
              <CriteriaCard errorCount={clientErrors.length} onClick={showCriteria.bind(null, 'client')} title='Client Info'>
                {client ? (
                  <>
                    <Copy color={clientErrors.includes('first_name') || clientErrors.includes('last_name') ? 'RED' : 'BLACK'}>
                      {!client.first_name || !client.last_name ? 'Missing Name' : `${client.first_name} ${client.last_name}`}
                    </Copy>
                    <Copy>{client.date_of_birth || `${client?.current_age} (${client?.nearest_age})`}</Copy>
                    <Copy>{client.gender}</Copy>
                    <Copy>{client.state}</Copy>
                  </>
                ) : null}
              </CriteriaCard>
              <CriteriaCard errorCount={productErrors.length} onClick={showCriteria.bind(null, 'product')} title='Product Criteria'>
                {product ? (
                  <>
                    <Copy>{product.product_types ? product.product_types[0] : null}</Copy>
                    <Copy color={productErrors.includes('carrier_ids') ? 'RED' : 'BLACK'}>{product?.carrier_ids?.length ? `${product.carrier_ids.length} Carriers` : 'Missing Carriers'}</Copy>
                    <Copy>AM Best {product.am_best_rating}</Copy>
                    {['Fixed Annuity', 'Fixed Indexed Annuity'].includes(product?.product_types[0]) && <Copy>SCP {product?.surrender_charge_period ? product?.surrender_charge_period : 'Any'}</Copy>}
                    {['Multi-Year Guaranteed Annuity', 'Fixed Annuity'].includes(product?.product_types[0]) && (
                      <Copy>GP {product?.guaranteed_period ? parseInt(product?.guaranteed_period?.length) : 0}</Copy>
                    )}
                    <Copy>{product.features ? `${product.features.length} Features` : 'No Features'}</Copy>
                    <Copy>{product.tax_qualification}</Copy>
                  </>
                ) : null}
              </CriteriaCard>
              <CriteriaCard errorCount={solveErrors.length} onClick={showCriteria.bind(null, 'solve')} title='Solve Data'>
                {solve ? (
                  <>
                    <Copy>Solve For {solve.solve_for}</Copy>
                    <Copy color={solveErrors.includes('premium') ? 'RED' : 'BLACK'}>{Numeral(solve.premium).format('$0,0') || 'Contribution Missing'}</Copy>
                    <Copy>
                      {solve.solve_for === 'Contribution' ? 'Accumulated to the end of year: ' : 'Quote value at the end of year: '} {solve?.quote_value ? `${solve.quote_value} Year` : '1 Year'}
                    </Copy>
                  </>
                ) : null}
              </CriteriaCard>
            </Criteria>
            <Results>
              <ResultsBar
                disabled={!quotes.length}
                filters={filters}
                onCompare={handleCompareSelected}
                onFilter={handleFilterChange}
                onShare={handleShare}
                paginationQuotes={paginationQuotes}
                resultsCount={quotes.length || 0}
                selectedCount={selectedQuotes.length}
                selectedQuotes={selectedQuotes}
                setPaginationQuotes={setPaginationQuotes}
                setQuoteCount={setQuoteCount}
                setSelectedQuotes={setSelectedQuotes}
                solveFor={solve?.solve_for}
                visible_quotes={visible_quotes || []}
              />
              {first_view || invalid_criteria ? (
                <EmptyState>
                  <EmptyStateContent>
                    {first_view ? (
                      <ZeroState
                        action={{
                          children: 'Start Entering Criteria',
                          icon: mdiChevronRight,
                          onClick: showCriteria.bind(null, 'agent')
                        }}
                        description='Click into the boxes above to enter your quote criteria. Results will appear in this area once the required criteria has been entered.'
                        icon={mdiCalculator}
                        title='Getting Started'
                      />
                    ) : (
                      <ZeroState
                        action={{
                          children: 'Edit Criteria',
                          icon: mdiChevronRight,
                          onClick: showCriteria.bind(null, 'agent')
                        }}
                        description='More information is needed before quotes can be displayed'
                        icon={mdiProgressCheck}
                        title='Almost There...'
                      />
                    )}
                  </EmptyStateContent>
                </EmptyState>
              ) : (
                <>
                  {loadingQuotes && !error ? (
                    <Quotes>
                      <LoadingQuote key='loading-1' />
                      <LoadingQuote key='loading-2' />
                    </Quotes>
                  ) : (
                    <>
                      {visible_quotes.length && selectedQuotes.length ? (
                        <Alert
                          description='This quote is non-binding and subject to change. A quote is only official after an application is submitted to an insurance company, they have approved you for a policy, and they state it is official.'
                          title='Disclosure'
                          type='warning'
                        />
                      ) : null}

                      {paginationQuotes.length ? (
                        <Quotes>
                          {loadedQuotes?.map((q, index) => {
                            const carrier = carriers?.find(c => c.id === q.carrier_id);
                            const carrier_product = products?.find(p => p.id === q.product_id);

                            return (
                              <motion.div animate={{ opacity: 1, y: 0 }} initial={{ opacity: 0, y: 50 }} key={`${q.product_id} - ${index}`} transition={{ delay: index * 0.1 }}>
                                <QuoteCard
                                  carrier={carrier}
                                  index={index}
                                  hasActions={!!quoter.quote_actions.find(a => a.carrier_ids.includes(q.carrier_id) && a.product_ids.includes(q.product_id))}
                                  isSelected={selectedQuotes.includes(q.id)}
                                  modal={handleModal}
                                  onSelect={handleQuoteSelect}
                                  onShowActions={handleShowQuoteActions}
                                  product={carrier_product}
                                  productType={product?.product_types[0]}
                                  quote={q}
                                  selectedQuotes={selectedQuotes}
                                  solveFor={solve.solve_for}
                                />
                              </motion.div>
                            );
                          })}
                        </Quotes>
                      ) : (
                        <EmptyState>
                          <EmptyStateContent>
                            <ZeroState
                              action={{
                                children: 'Adjust Criteria',
                                icon: mdiChevronRight,
                                onClick: showCriteria.bind(null, 'product')
                              }}
                              description='Adjust the criteria above to run a new search.'
                              icon={mdiCalculator}
                              title='No Matching Quotes'
                            />
                          </EmptyStateContent>
                        </EmptyState>
                      )}
                    </>
                  )}
                </>
              )}
            </Results>
          </Widget>
        </ProductContext.Provider>
      </ThemeContext.Provider>
    </ThemeProvider>
  );
};

const container = document.getElementById('hexure-annuities-quoter');
const root = createRoot(container);
root.render(
  <PostHogProvider client={posthog}>
    <AnnuitiesQuoter />
  </PostHogProvider>
);
